import { render, staticRenderFns } from "./DefaultItemInformation.vue?vue&type=template&id=1bd0847a&"
import script from "./DefaultItemInformation.vue?vue&type=script&lang=js&"
export * from "./DefaultItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports